import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth.guard';

// Import Containers
import { DefaultLayoutComponent } from './containers';
import { LoginComponent } from './views/login/login.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'organizations',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Bejelentkezés',
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'organizations',
        loadChildren: () => import('./views/organizations/organizations.module').then(m => m.OrganizationsModule),
        data: {
          title: 'Üzletek',
        }
      },
      {
        path: 'cameras',
        loadChildren: () => import('./views/cameras/cameras.module').then(m => m.CamerasModule)
      },
      {
        path: 'audits',
        loadChildren: () => import('./views/audits/audits.module').then(m => m.AuditsModule)
      }
    ]
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
    onSameUrlNavigation: 'reload'
  }) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
